import { render, staticRenderFns } from "./StartseiteIcon.vue?vue&type=template&id=3c01bafe"
import script from "./StartseiteIcon.vue?vue&type=script&lang=js"
export * from "./StartseiteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports